import classNames from "classnames";
import type { ReactNode } from "react";

interface PanelProps {
    /**
     * The panel header title.
     */
    title?: string;
    /**
     * Additional CSS class name.
     */
    className?: string;
    /**
     * The panel content.
     */
    children?: ReactNode;
}

/**
 * Base panel wrapper with an optional title header.
 *
 * @param {PanelProps} props - The component props.
 * @returns {ReactNode} The rendered panel.
 */
const Panel = ({ title, className, children }: PanelProps): ReactNode => (
    <div className={classNames("default-panel", className)}>
        {title && <div className="panel-title">{title}</div>}
        <div className="panel-content">{children}</div>
    </div>
);

export default Panel;
